<template>
  <p class="text-body-2 text-right text-textDark">
    {{ label }}
    <span class="count-number">
      {{ count }}
    </span>
  </p>
</template>

<script setup>
import { onBeforeUnmount } from 'vue';
import { useDatasetCounts } from '@/stores/insights/datasetCounts';

defineProps({
  label: {
    type: String,
    default: '',
  },
  count: {
    type: String,
    default: '',
  },
});

const { setDatasetCounts } = useDatasetCounts();

onBeforeUnmount(() => {
  setDatasetCounts(0);
});
</script>

<style lang="less" scoped>
.count-number {
  color: @basic-green;
}
</style>
